import type { VendorMetadataExtractor, ExtractedIncidentMeta } from './types'

export const nextbaseExtractor: VendorMetadataExtractor = {
  vendorId: 'nextbase',
  vendorLabel: 'Nextbase',
  supportsDirectoryBrowse: false,

  async extractFromFiles(files: File[]): Promise<ExtractedIncidentMeta | null> {
    // Nextbase embeds telemetry in proprietary MP4 boxes or separate .NBD sidecar files.
    // Client-side parsing is not feasible without the Nextbase SDK. Falls back to file timestamp.
    const first = files[0]
    if (!first) return null
    return { dateTime: new Date(first.lastModified) }
  }
}
